/**
 * @file ZapierWordmark.tsx
 * @brief Zapier's own wordmark in place of the word "Zapier" (W31), theme-aware
 *        the same way as BrandWordmark: both files rendered, `dark:` swaps them.
 *
 * @details
 * The files are Zapier's, as DES saved them (27-10-2026), and are shown
 * UNMODIFIED: no recolour, crop or redraw. Height only; the width follows.
 * Not on the consent screen, which stays VERBLIZR only.
 * Asana has no logo anywhere: its brand rules forbid the symbol on its own,
 * so it stays text.
 *
 * @dependencies
 * - WEBPANEL/public/brand/partners/zapier-wordmark-dark.png       (light theme)
 * - WEBPANEL/public/brand/partners/zapier-wordmark-white_png.png  (dark theme)
 *
 * @author DES (prepared with Claude)
 * @date 27-10-2026
 */

import { cn } from "@/shared/theme/cn";

export function ZapierWordmark({ height = 22, className }: { height?: number; className?: string }) {
  return (
    <span className={cn("inline-flex shrink-0 items-center", className)} style={{ height }}>
      <img
        src="/brand/partners/zapier-wordmark-dark.png"
        alt="Zapier"
        height={height}
        draggable={false}
        className="block h-full w-auto select-none dark:hidden"
      />
      <img
        src="/brand/partners/zapier-wordmark-white_png.png"
        alt="Zapier"
        height={height}
        draggable={false}
        className="hidden h-full w-auto select-none dark:block"
      />
    </span>
  );
}
